import React from "react";
import { Box, Paper, Typography, Alert } from "@mui/material";

const PreviewStep = ({ parsedIds, errorMsg, minHeight }) => {
  const baseMin = typeof minHeight === "number" ? minHeight : 295;
  const headerAndGapsPx = errorMsg ? 120 : 80;
  const listMaxHeight = Math.max(160, baseMin - headerAndGapsPx);
  
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        mb: 3,
        borderRadius: 2,
        border: "1px solid #eaeaea",
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
        Customer Address Numbers ({parsedIds.length})
      </Typography>

      {errorMsg && (
        <Alert severity="error" sx={{ mb: 2, fontSize: { xs: "1.2rem", sm: "1.3rem" } }}>
          {errorMsg}
        </Alert>
      )}

      <Box
        sx={{
          maxHeight: listMaxHeight,
          overflowY: "auto",
          overflowX: "hidden",
          border: "1px solid #eee",
          borderRadius: 1,
          pr: 1,
        }}
      >
        {parsedIds.map((id) => (
          <Box
            key={id}
            sx={{ p: 1.25, borderBottom: "1px solid #f2f2f2", fontSize: { xs: "1.2rem", sm: "1.3rem" } }}
          >
            {id}
          </Box>
        ))}

        {parsedIds.length === 0 && (
          <Box sx={{ p: 1.25, fontSize: { xs: "1.2rem", sm: "1.3rem" }, color: "text.secondary" }}>
            No customer numbers detected.
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default PreviewStep;
